import { render, staticRenderFns } from "./columns.vue?vue&type=template&id=474fe104&scoped=true"
import script from "./columns.vue?vue&type=script&lang=js"
export * from "./columns.vue?vue&type=script&lang=js"
import style0 from "./columns.vue?vue&type=style&index=0&id=474fe104&prod&scoped=true&lang=scss"
import style1 from "./columns.vue?vue&type=style&index=1&id=474fe104&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474fe104",
  null
  
)

export default component.exports